// extracted by mini-css-extract-plugin
export default {"content":"CardPreview_content__rk6Zj","content__icon":"CardPreview_content__icon__I0QGf","content__description":"CardPreview_content__description__5QRgp"};